export default {"src":"/_next/static/media/app_store_badge.66750818.svg","height":70,"width":200};